<template>
  <div class="index-wrapper">
    <header-vue></header-vue>
    <div class="map-warpper">
      <a-map></a-map>
    </div>
    <div class="mask-bottom"></div>
    <div class="index-left">
      <div class="index-overview">
        <min-box titleName="概览">
          <div class="data-line">
            <div class="pull-left overview-min">
              <div class="out-line">
                <div class="overview-title">纠纷总量</div>
                <div class="overview-contentdata">
                  <div class="overview-data">
                    <countTo :startVal="0" :endVal="58968" :duration="3000"></countTo>
                  </div>
                </div>
              </div>
            </div>
            <div class="pull-left overview-min">
              <div class="out-line">
                <div class="overview-title">已处置量</div>
                <div class="overview-contentdata">
                  <div class="overview-data">
                    <countTo :startVal="0" :endVal="52345" :duration="3000"></countTo>
                  </div>
                </div>
              </div>
            </div>

            <div class="pull-left overview-min">
              <div class="out-line">
                <div class="overview-title">未分配量</div>
                <div class="overview-contentdata">
                  <div class="overview-data">
                    <countTo :startVal="0" :endVal="234" :duration="3000"></countTo>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="data-line">
            <div class="pull-left overview-min">
              <div class="out-line">
                <div class="overview-title">今日纠纷</div>
                <div class="overview-contentdata">
                  <div class="overview-data">
                    <countTo :startVal="0" :endVal="3364" :duration="3000"></countTo>
                    <!-- <div class="overview-state down"> -->
                    <!-- <span class="iconfont overview-arrowicon"></span> -->
                    <!-- <span class="overview-precent">5%</span> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="pull-left overview-min">
              <div class="out-line">
                <div class="overview-title">今日处置</div>
                <div class="overview-contentdata">
                  <div class="overview-data">
                    <countTo :startVal="0" :endVal="3000" :duration="3000"></countTo>
                    <!-- <div class="overview-state"> -->
                    <!-- <span class="iconfont overview-arrowicon"></span> -->
                    <!-- <span class="overview-precent">5%</span> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="pull-left overview-min">
              <div class="out-line">
                <div class="overview-title">今日未派</div>
                <div class="overview-contentdata">
                  <div class="overview-data">
                    <countTo :startVal="0" :endVal="364" :duration="3000"></countTo>
                    <!-- <div class="overview-state"> -->
                    <!-- <span class="iconfont overview-arrowicon"></span> -->
                    <!-- <span class="overview-precent">5%</span> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </min-box>
      </div>
      <div class="index-power">
        <min-box titleName="实时力量">
          <div class="power-title-line">
            <div class="pull-left power-title-box">
              <div class="power-num">
                <countTo :startVal="0" :endVal="1234" :duration="3000"></countTo>
              </div>
              <div class="power-title-name" @click="showDispatcher">调度员</div>
              <div class="power-arrow"></div>
            </div>
            <div class="pull-right power-title-box">
              <div class="power-num">
                <countTo :startVal="0" :endVal="1234" :duration="3000"></countTo>
              </div>
              <div class="power-title-name" @click="showMediator">调解员</div>
              <div class="power-arrow"></div>
            </div>
          </div>
          <div class="power-scroll-content">
            <el-scrollbar class="power-content">
              <a
                href="javascript:;"
                class="mediate-msg"
                :class="item.status"
                v-for="(item,index) in powerList"
                :key="index"
              >
                <span class="pull-left warn-msg-icon"></span>
                <span class="pull-left msg-person">{{item.name}}</span>
                <span class="pull-left msg-type">{{item.type}}</span>
                <span class="pull-right msg-nums" v-if="item.status === 'repeat'">重复报警</span>
                <span class="pull-right msg-nums" v-else>
                  已流转
                  <span>{{item.time}}</span>次
                </span>
              </a>
            </el-scrollbar>
          </div>
        </min-box>
      </div>
      <div class="index-ranking">
        <min-box titleName="纠纷分布排行" chooseType="rankType" v-on:chType="chType">
          <div class="rank-content-box">
            <el-scrollbar class="rank-content">
              <div class="chart-rank">
                <bar-chart :chartData="rankData" chartId="rank-chart"></bar-chart>
              </div>
            </el-scrollbar>
          </div>
        </min-box>
      </div>
      <div class="index-search">
        <div class="iconfont search-icon-btn iconsousuo"></div>
        <input class="search-box" type="text" placeholder="请输入关键词检索">
      </div>
    </div>
    <div class="index-right">
      <div class="index-110">
        <min-box titleName="实时警情播报" linkurl="javascript:;" linkname="更多警情" v-on:more="moreWindow">
          <div class="police-content">
            <el-scrollbar class="police-list">
              <ul class="list-page">
                <li class="list-item" v-for="(item,index) in policeList" :key="index">
                  <a href="javascript:;" style="display:block;">
                    <div class="list-time">2019-02-03 20:02:38</div>
                    <div class="list-content">
                      <div class="police-master">{{item.master}}</div>
                      <div class="content-line clearfix">
                        <div class="pull-left">当事人：{{item.person}}</div>
                        <div class="pull-right">出动单位：{{item.place}}</div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </min-box>
      </div>
      <div class="index-analysis">
        <min-box titleName="纠纷特征分析" chooseType="analysisType" v-on:chType="chType">
          <div class="padding-20"></div>
          <div class="content-tabbar clearfix">
            <div
              class="pull-left content-tab"
              :class="[analyActive ==='type'? 'active':'']"
              @click="analyActive='type'"
            >纠纷类型</div>
            <div
              class="pull-left content-tab"
              :class="[analyActive !=='type'? 'active':'']"
              @click="analyActive='result'"
            >处置结果</div>
          </div>
          <div class="analysis-chart">
            <pie-chart
              :chartData="analysisTypeData"
              v-if="analyActive==='type'"
              chartId="analysisType-chart"
            ></pie-chart>
            <pie-chart :chartData="analysisResultData" v-else chartId="analysisType-result"></pie-chart>
          </div>
        </min-box>
      </div>
      <div class="index-trend">
        <min-box titleName="转入调解事件趋势" chooseType="trendType" v-on:chType="chType">
          <div class="padding-20"></div>
          <div class="content-tabbar clearfix">
            <div
              class="pull-left content-tab"
              :class="[trendActive ==='trend'? 'active':'']"
              @click="trendActive='trend'"
            >转入调解事件趋势</div>
            <div
              class="pull-left content-tab"
              :class="[trendActive ==='analy'? 'active':'']"
              @click="trendActive='analy'"
            >处置趋势分析</div>
          </div>
          <div class="trend-chart">
            <column-chart v-if="trendActive==='trend'" :chartData="trendData" chartId="trend-chart"></column-chart>
            <lines-chart v-else :chartData="analysData" chartId="analys-chart"></lines-chart>
          </div>
        </min-box>
      </div>
      <el-select
        class="map-select-area"
        v-model="areaValue"
        placeholder="区域选择"
        popper-class="select-class"
      >
        <el-option
          v-for="item in areaOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        class="map-select-name"
        v-model="placeValue"
        placeholder="全部司法所"
        popper-class="select-class"
      >
        <el-option
          v-for="item in placeOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="index-bottom">
      <min-box titleName="实时处置流程">
        <div class="progress-course">
          <div class="pull-left progress-person icondadianhua iconfont"></div>
          <div class="pull-left progress-arrow"></div>
          <div class="pull-left progress-police">
            <div>
              110接警中心
              <div class="progress-num">400</div>
            </div>
          </div>
          <div class="pull-left progress-arrow"></div>
          <div class="pull-left progress-web">
            <div>
              纠纷类警情协同共治平台
              <div class="progress-num">378</div>
            </div>
          </div>
          <div class="pull-left progress-arrow"></div>
          <div class="pull-left progress-center">
            <div>
              调度中心
              <div class="progress-num">265</div>
            </div>
          </div>
          <div class="pull-left progress-arrow"></div>
          <div class="pull-left progress-branch">
            <div class="branch-first">
              <div class="barnch-top">
                <span>非纠纷类退单</span>
                <br>
                <span class="branch-num num-orange">15</span>
              </div>
              <div class="branch-center">
                <span>调解中</span>
                <br>
                <span class="branch-num num-blue">26</span>
              </div>
              <div class="branch-end">
                <span>无法联系</span>
                <br>
                <span class="branch-num num-red">32</span>
              </div>
            </div>
            <div class="branch-second">
              <div class="barnch-top">
                <span>纠纷缓解</span>
                <br>
                <span class="branch-num num-orange">15</span>
              </div>
              <div class="branch-center">
                <span>处置完成</span>
                <br>
                <span class="branch-num num-green">26</span>
              </div>
              <div class="branch-end">
                <span>拒绝调解</span>
                <br>
                <span class="branch-num num-red">32</span>
              </div>
            </div>
            <div class="branch-line-first">
              <div class="branch-content-box">
                <div class="branch-line"></div>
                <div class="branch-line branch-line2"></div>
                <div class="branch-line branch-line3"></div>
                <div class="branch-rotate-line"></div>
                <div class="branch-rotate-line branch-rotate-line2"></div>
              </div>
            </div>
            <div class="branch-line-first branch-line-second">
              <div class="branch-content-box">
                <div class="branch-line"></div>
                <div class="branch-line branch-line2"></div>
                <div class="branch-line branch-line3"></div>
                <div class="branch-rotate-line"></div>
                <div class="branch-rotate-line branch-rotate-line2"></div>
              </div>
            </div>
          </div>
        </div>
      </min-box>
    </div>
    <div class="index-top" :class="{'down-move': addDowm}" v-show="visibleWindow">
      <detail-box
        titleName="实时警情播报"
        v-on:hideDetail="hideDetail"
        v-if="showtype === 'broadcastList'"
      >
        <el-scrollbar class="scroll-deatil">
          <div class="detail-content-box">
            <ul class="broadcas-list">
              <li class="broadcas-title clearfix">
                <div class="pull-left broadcast-num">案号</div>
                <div class="pull-left broadcast-time">报警时间</div>
                <div class="pull-left broadcast-person">当事人</div>
                <div class="pull-left broadcast-disc">描述</div>
                <div class="pull-left broadcast-status">状态</div>
              </li>
              <li
                class="broadcas-list-item"
                v-for="(item,index) in broadcast"
                :key="index"
                @click="broadcastDetail(index)"
              >
                <a class="broadcas-item clearfix" href="javascript:;">
                  <div class="pull-left broadcast-num">{{item.num}}</div>
                  <div class="pull-left broadcast-time">{{item.time}}</div>
                  <div class="pull-left broadcast-person">{{item.person}}</div>
                  <div class="pull-left broadcast-disc">{{item.disc}}</div>
                  <div class="pull-left broadcast-status wait" v-if="item.status==='wait'">待分派</div>
                  <div
                    class="pull-left broadcast-status bureaus"
                    v-if="item.status==='bureaus'"
                  >已派区局</div>
                  <div
                    class="pull-left broadcast-status office"
                    v-if="item.status==='office'"
                  >转司法所/派专调</div>
                  <div
                    class="pull-left broadcast-status committee"
                    v-if="item.status==='committee'"
                  >已派调委会</div>
                  <div class="pull-left broadcast-status end" v-if="item.status==='end'">已处置</div>
                  <div
                    class="pull-left broadcast-status receive"
                    v-if="item.status==='receive'"
                  >司法所已接收</div>
                </a>
              </li>
            </ul>
          </div>
        </el-scrollbar>
      </detail-box>
      <detail-box
        titleName="实时警情播报"
        v-on:hideDetail="hideDetail"
        v-if="showtype === 'broadcastDetail'"
        listName="broadcastList"
        v-on:backList="backList"
      >
        <el-scrollbar class="scroll-deatil">
          <div class="mediator-detail dispatcher">
            <div class="detail-inner">
              <div class="broadcast-link-btn">
                <div class="iconfont iconshipinlianxian"></div>连线
              </div>
              <div class="broadcast-detail-title clearfix">
                <div class="pull-left iconfont iconanli"></div>
                <div class="pull-left">案号：23782116371263781263</div>
              </div>
              <ul class="broadcast-detail-record">
                <li class="broadcast-record-item">
                  <div class="record-time">2017-08-23</div>
                  <div class="record-content">王月冰（1378764578）拨打110</div>
                </li>
              </ul>
              <div class="show-more-btn">
                展开更多
                <div class="more-arrow"></div>
              </div>
            </div>
            <div class="detail-inner">
              <div class="detail-title">基本信息</div>
              <div class="detail-body clearfix">
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">案号：23782116371263781263</div>
                  <div class="pull-left other-msg detail-info">案由：家庭婚姻纠纷</div>
                  <div class="pull-left other-msg detail-info">报警人：付晓晓</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">警情描述：家庭纠纷 请民警到场处理</div>
                  <div class="pull-left other-msg detail-info">事发地址：浙江省杭州市西湖区万塘路18号</div>
                  <div class="pull-left other-msg detail-info">联系电话：13678967856</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">联系地址：上海市浦东新区后滩</div>
                  <div class="pull-left other-msg detail-info">首次报警时间：2019-03-16 16:50:03</div>
                </div>
              </div>
            </div>
            <div class="detail-inner">
              <div class="detail-title">处置信息</div>
              <div class="detail-body clearfix">
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">处置情况：纠纷缓解</div>
                  <div class="pull-left other-msg detail-info">处置人员：张二</div>
                  <div class="pull-left other-msg detail-info">所在人群：未成年人</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">处置日期：2019-03-16 16:50:08</div>
                  <div class="pull-left other-msg detail-info">是否现场处置：是</div>
                  <div class="pull-left other-msg detail-info">当事人是否接受了告知：是</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">拒绝方式：现场拒绝</div>
                  <div class="pull-left other-msg detail-info">是否告知诉求途径：是</div>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </detail-box>
      <detail-box titleName="调度员" v-on:hideDetail="hideDetail" v-if="showtype === 'dispatcherList'">
        <el-scrollbar class="scroll-deatil">
          <div class="detail-content-box">
            <div class="peopleList-nav clearfix">
              <el-select
                class="nav-area"
                v-model="areaValue"
                placeholder="区域选择"
                popper-class="select-class list-select"
              >
                <el-option
                  v-for="item in areaOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                class="nav-place"
                v-model="placeValue"
                placeholder="全部司法所"
                popper-class="select-class list-select"
              >
                <el-option
                  v-for="item in placeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="pull-right">共123人</div>
            </div>
            <ul class="peopleList-content-box clearfix">
              <li
                class="peopleList-box"
                v-for="(item,index) in dispatcher"
                :key="index"
                @click="dispatcherDeatil(index)"
              >
                <div class="peopleList-img" :style="{'background-image': 'url(' + item.img + ')'}"></div>
                <div class="peopleList-name">{{item.name}}</div>
                <div class="peopleList-place">{{item.place}}</div>
              </li>
            </ul>
          </div>
        </el-scrollbar>
      </detail-box>
      <detail-box titleName="调解员" v-on:hideDetail="hideDetail" v-if="showtype === 'mediatorList'">
        <el-scrollbar class="scroll-deatil">
          <div class="detail-content-box">
            <div class="peopleList-nav clearfix">
              <el-select
                class="nav-area"
                v-model="areaValue"
                placeholder="区域选择"
                popper-class="select-class list-select"
              >
                <el-option
                  v-for="item in areaOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                class="nav-place"
                v-model="placeValue"
                placeholder="全部司法所"
                popper-class="select-class list-select"
              >
                <el-option
                  v-for="item in placeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div class="pull-right">共123人</div>
            </div>
            <ul class="peopleList-content-box clearfix">
              <li
                class="peopleList-box"
                v-for="(item,index) in mediator"
                :key="index"
                @click="mediatorDeatil(index)"
              >
                <div class="peopleList-img" :style="{'background-image': 'url(' + item.img + ')'}"></div>
                <div class="peopleList-name">{{item.name}}</div>
                <div class="peopleList-place">{{item.place}}</div>
              </li>
            </ul>
          </div>
        </el-scrollbar>
      </detail-box>
      <detail-box
        titleName="调度员"
        v-on:hideDetail="hideDetail"
        v-if="showtype === 'dispatcherDetail'"
        listName="dispatcherList"
        v-on:backList="backList"
      >
        <el-scrollbar class="scroll-deatil">
          <div class="mediator-detail dispatcher">
            <div class="detail-inner">
              <div class="detail-title">基本信息</div>
              <div class="detail-body clearfix">
                <div class="pull-left head-portrait">
                  <img class="head-pic" src="../../public/images/yardman.png" alt>
                </div>
                <div class="pull-left basic-msg">
                  <div class="name">
                    付小小
                    <span class="type">(调度员)</span>
                  </div>
                  <div class="other-msg">行政职务：所长</div>
                  <div class="clearfix">
                    <div class="pull-left other-msg middle">性别：女</div>
                    <div class="pull-left other-msg middle">出生日期：2019-03-16</div>
                    <div class="pull-left other-msg middle">联系电话：18100000000</div>
                  </div>
                  <div class="clearfix">
                    <div class="pull-left other-msg">工作单位：上海市徐汇区华泾镇华阳司法所</div>
                  </div>
                  <div class="sirens-num-wrap">
                    <div class="pull-left mr-80">
                      <div class="num-hd">调度警情</div>
                      <div class="num-bd">256件</div>
                    </div>
                    <div class="pull-left">
                      <div class="num-hd">处置警情</div>
                      <div class="num-bd">256件</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-inner">
              <div class="detail-title">详细信息</div>
              <div class="detail-body clearfix">
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">编制：政法专项编</div>
                  <div class="pull-left other-msg detail-info">职级：正处级</div>
                  <div class="pull-left other-msg detail-info">民族：汉</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">国籍：中国</div>
                  <div class="pull-left other-msg detail-info">所学专业：其他</div>
                  <div class="pull-left other-msg detail-info">是否负责人：是</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">产生方式：推选</div>
                  <div class="pull-left other-msg detail-info">人员类型：司法所公务员</div>
                  <div class="pull-left other-msg detail-info">任职方式：专职</div>
                </div>
              </div>
            </div>
            <div class="detail-inner">
              <div class="detail-title">其他信息</div>
            </div>
          </div>
        </el-scrollbar>
      </detail-box>
      <detail-box
        titleName="调解员"
        v-on:hideDetail="hideDetail"
        v-if="showtype === 'mediatorDetail'"
        listName="mediatorList"
        v-on:backList="backList"
      >
        <el-scrollbar class="scroll-deatil">
          <div class="mediator-detail mediator">
            <div class="detail-inner">
              <div class="detail-title">基本信息</div>
              <div class="detail-body clearfix">
                <div class="pull-left head-portrait">
                  <img class="head-pic" src="../../public/images/head_pic.png" alt>
                </div>
                <div class="pull-left basic-msg">
                  <div class="name">
                    黄文斌
                    <span class="type">(调解员)</span>
                  </div>
                  <div class="other-msg">行政职务：所长</div>
                  <div class="clearfix">
                    <div class="pull-left other-msg middle">性别：女</div>
                    <div class="pull-left other-msg middle">出生日期：2019-03-16</div>
                    <div class="pull-left other-msg middle">联系电话：18100000000</div>
                  </div>
                  <div class="clearfix">
                    <div class="pull-left other-msg">工作单位：上海市徐汇区华泾镇华阳司法所</div>
                  </div>
                  <div class="sirens-num-wrap">
                    <div class="pull-left mr-80">
                      <div class="num-hd">调度警情</div>
                      <div class="num-bd">256件</div>
                    </div>
                    <div class="pull-left">
                      <div class="num-hd">调度警情</div>
                      <div class="num-bd">256件</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-inner">
              <div class="detail-title">详细信息</div>
              <div class="detail-body clearfix">
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">产生方式：推选</div>
                  <div class="pull-left other-msg detail-info">任职方式：专职</div>
                  <div class="pull-left other-msg detail-info">是否政府购买服务：是</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">身份职业：村（居）委会干部</div>
                  <div class="pull-left other-msg detail-info">是否从事过相关工作或具有相关知识储备：是</div>
                  <div class="pull-left other-msg detail-info">兼职其他工作：无</div>
                </div>
                <div class="clearfix">
                  <div class="pull-left other-msg detail-info">产生方式：推选</div>
                  <div class="pull-left other-msg detail-info">权限：调解委员会审核人员</div>
                </div>
              </div>
            </div>
            <div class="detail-inner">
              <div class="detail-title">
                其他信息
              </div>
            </div>
          </div>
        </el-scrollbar>
      </detail-box>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import aMap from "../components/aMap.vue";
import headerVue from "../components/header";
import minBox from "../components/min-box.vue";
import barChart from "../components/bar-chart.vue";
import pieChart from "../components/pie-chart.vue";
import columnChart from "../components/column-chart.vue";
import linesChart from "../components/lines-chart.vue";
import detailBox from "../components/detail-box";
import countTo from "vue-count-to";

export default {
  components: {
    aMap,
    headerVue,
    minBox,
    barChart,
    pieChart,
    columnChart,
    linesChart,
    detailBox,
    countTo
  },
  name: "index",
  data() {
    return {
      rankData: [
        {
          name: "徐汇区",
          value: 0
        },
        {
          name: "静安区",
          value: 0
        },
        {
          name: "黄浦区",
          value: 0
        },
        {
          name: "奉贤区",
          value: 0
        },
        {
          name: "青浦区",
          value: 0
        },
        {
          name: "浦东新区",
          value: 0
        },
        {
          name: "松江区",
          value: 0
        },
        {
          name: "闵行区",
          value: 0
        },
        {
          name: "宝山区",
          value: 0
        },
        {
          name: "嘉定区",
          value: 0
        },
        {
          name: "金山区",
          value: 0
        },
        {
          name: "虹口区",
          value: 0
        },
        {
          name: "杨浦区",
          value: 0
        },
        {
          name: "普陀区",
          value: 0
        },
        {
          name: "长宁区",
          value: 0
        },
        {
          name: "崇明区",
          value: 0
        }
      ],
      analysisTypeData: [
        {
          type: "邻里纠纷",
          value: 40
        },
        {
          type: "医患纠纷",
          value: 21
        },
        {
          type: "婚姻家庭纠纷",
          value: 17
        },
        {
          type: "其他纠纷",
          value: 22
        }
      ],
      analysisResultData: [
        {
          type: "处置完成",
          value: 40
        },
        {
          type: "纠纷缓解",
          value: 21
        },
        {
          type: "非纠纷类退单",
          value: 17
        },
        {
          type: "无法联系",
          value: 13
        },
        {
          type: "拒绝调解",
          value: 9
        }
      ],
      trendData: [
        {
          name: "total",
          date: "03-21",
          value: 0
        },
        {
          name: "total",
          date: "03-20",
          value: 0
        },
        {
          name: "total",
          date: "03-19",
          value: 0
        },
        {
          name: "total",
          date: "03-18",
          value: 0
        },
        {
          name: "total",
          date: "03-17",
          value: 0
        },
        {
          name: "total",
          date: "03-16",
          value: 0
        },
        {
          name: "total",
          date: "03-15",
          value: 0
        },
        {
          name: "total",
          date: "03-14",
          value: 0
        },
        {
          name: "total",
          date: "03-13",
          value: 0
        },
        {
          name: "mediate",
          date: "03-21",
          value: 0
        },
        {
          name: "mediate",
          date: "03-20",
          value: 0
        },
        {
          name: "mediate",
          date: "03-19",
          value: 0
        },
        {
          name: "mediate",
          date: "03-18",
          value: 0
        },
        {
          name: "mediate",
          date: "03-17",
          value: 0
        },
        {
          name: "mediate",
          date: "03-16",
          value: 0
        },
        {
          name: "mediate",
          date: "03-15",
          value: 0
        },
        {
          name: "mediate",
          date: "03-14",
          value: 0
        },
        {
          name: "mediate",
          date: "03-13",
          value: 0
        }
      ],
      analysData: [
        {
          date: "2019/03/01",
          type: "处置完成",
          value: 4623
        },
        {
          date: "2019/03/01",
          type: "非纠纷类退单",
          value: 2208
        },
        {
          date: "2019/03/01",
          type: "无法联系",
          value: 182
        },
        {
          date: "2019/03/02",
          type: "处置完成",
          value: 6145
        },
        {
          date: "2019/03/02",
          type: "非纠纷类退单",
          value: 2016
        },
        {
          date: "2019/03/02",
          type: "无法联系",
          value: 257
        },
        {
          date: "2019/03/03",
          type: "处置完成",
          value: 508
        },
        {
          date: "2019/03/03",
          type: "非纠纷类退单",
          value: 2916
        },
        {
          date: "2019/03/03",
          type: "无法联系",
          value: 289
        },
        {
          date: "2019/03/04",
          type: "处置完成",
          value: 6268
        },
        {
          date: "2019/03/04",
          type: "非纠纷类退单",
          value: 4512
        },
        {
          date: "2019/03/04",
          type: "无法联系",
          value: 428
        },
        {
          date: "2019/03/05",
          type: "处置完成",
          value: 6411
        },
        {
          date: "2019/03/05",
          type: "非纠纷类退单",
          value: 8281
        },
        {
          date: "2019/03/05",
          type: "无法联系",
          value: 619
        },
        {
          date: "2019/03/06",
          type: "处置完成",
          value: 1890
        },
        {
          date: "2019/03/06",
          type: "非纠纷类退单",
          value: 2008
        },
        {
          date: "2019/03/06",
          type: "无法联系",
          value: 87
        },
        {
          date: "2019/03/07",
          type: "处置完成",
          value: 4251
        },
        {
          date: "2019/03/07",
          type: "非纠纷类退单",
          value: 1963
        },
        {
          date: "2019/03/07",
          type: "无法联系",
          value: 706
        },
        {
          date: "2019/03/08",
          type: "处置完成",
          value: 2978
        },
        {
          date: "2019/03/08",
          type: "非纠纷类退单",
          value: 2367
        },
        {
          date: "2019/03/08",
          type: "无法联系",
          value: 387
        },
        {
          date: "2019/03/09",
          type: "处置完成",
          value: 3880
        },
        {
          date: "2019/03/09",
          type: "非纠纷类退单",
          value: 2956
        },
        {
          date: "2019/03/09",
          type: "无法联系",
          value: 488
        },
        {
          date: "2019/03/10",
          type: "处置完成",
          value: 3606
        },
        {
          date: "2019/03/10",
          type: "非纠纷类退单",
          value: 678
        },
        {
          date: "2019/03/10",
          type: "无法联系",
          value: 507
        },
        {
          date: "2019/03/11",
          type: "处置完成",
          value: 4311
        },
        {
          date: "2019/03/11",
          type: "非纠纷类退单",
          value: 3188
        },
        {
          date: "2019/03/11",
          type: "无法联系",
          value: 548
        },
        {
          date: "2019/03/12",
          type: "处置完成",
          value: 4116
        },
        {
          date: "2019/03/12",
          type: "非纠纷类退单",
          value: 3491
        },
        {
          date: "2019/03/12",
          type: "无法联系",
          value: 456
        },
        {
          date: "2019/03/13",
          type: "处置完成",
          value: 6419
        },
        {
          date: "2019/03/13",
          type: "非纠纷类退单",
          value: 2852
        },
        {
          date: "2019/03/13",
          type: "无法联系",
          value: 689
        },
        {
          date: "2019/03/14",
          type: "处置完成",
          value: 1643
        },
        {
          date: "2019/03/14",
          type: "非纠纷类退单",
          value: 4788
        },
        {
          date: "2019/03/14",
          type: "无法联系",
          value: 280
        },
        {
          date: "2019/03/15",
          type: "处置完成",
          value: 445
        },
        {
          date: "2019/03/15",
          type: "非纠纷类退单",
          value: 4319
        },
        {
          date: "2019/03/15",
          type: "无法联系",
          value: 176
        }
      ],
      analyActive: "type",
      trendActive: "trend",
      areaOption: [
        {
          label: "徐汇区",
          value: 0
        },
        {
          label: "浦东新区",
          value: 1
        },
        {
          label: "宝山区",
          value: 2
        },
        {
          label: "长宁区",
          value: 3
        },
        {
          label: "闵行区",
          value: 4
        },
        {
          label: "黄浦区",
          value: 5
        }
      ],
      areaValue: "",
      placeOption: [
        {
          label: "徐汇区XXX",
          value: 0
        },
        {
          label: "浦东新区XXX",
          value: 1
        },
        {
          label: "宝山区XXX",
          value: 2
        },
        {
          label: "长宁区XXX",
          value: 3
        },
        {
          label: "闵行区XXX",
          value: 4
        },
        {
          label: "黄浦区XXX",
          value: 5
        }
      ],
      placeValue: "",
      powerList: [
        {
          name: "张小强",
          type: "邻里纠纷",
          time: 3,
          status: "new"
        },
        {
          name: "张小强",
          type: "邻里纠纷",
          time: 3,
          status: "new"
        },
        {
          name: "张小强",
          type: "邻里纠纷",
          time: 3,
          status: 'normal'
        },
        {
          name: "张小强",
          type: "邻里纠纷",
          time: 3,
          status: 'normal'
        },
        {
          name: "张小强",
          type: "邻里纠纷",
          time: 0,
          status: "repeat"
        }
      ],
      // 最新加载条数
      // newPower: 3,
      policeList: [
        {
          master: "王月冰",
          person: "王月冰",
          place: "浦东新区司法局"
        },
        {
          master: "王月冰",
          person: "王月冰",
          place: "浦东新区司法局"
        },
        {
          master: "王月冰",
          person: "王月冰",
          place: "浦东新区司法局"
        },
        {
          master: "王月冰",
          person: "王月冰",
          place: "浦东新区司法局"
        },
        {
          master: "王月冰",
          person: "王月冰",
          place: "浦东新区司法局"
        }
      ],
      broadcast: [
        {
          num: "20109000232023232232",
          person: "王老五",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "wait"
        },
        {
          num: "20109000233553232232",
          person: "张三",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "bureaus"
        },
        {
          num: "20109000232034534524",
          person: "李四",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "office"
        },
        {
          num: "20109000232023345332",
          person: "王二五",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "committee"
        },
        {
          num: "20109000345023232232",
          person: "张三",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "end"
        },
        {
          num: "20109000232023232236",
          person: "李四",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "receive"
        },
        {
          num: "20109000342023232232",
          person: "王老五",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "wait"
        },
        {
          num: "20109000232026732232",
          person: "王二五",
          time: "2019-09-21  08:50:08",
          disc: "这是一段描述，关于这条警情的描述",
          status: "wait"
        }
      ],
      visibleWindow: false,
      showtype: '',
      dispatcher: [
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/yardman.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        }
      ],
      mediator: [
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        },
        {
          img: './images/head_pic.png',
          name: '付晓晓',
          place: '徐汇区华泾镇华阳司法所'
        }
      ],
      addDowm: false
    }
  },
  methods: {
    ...mapActions([]),
    chType(e) {
      switch (e.chooseType) {
        case "rankType":
          this.rankType(e.type);
          break;
        case "analysisType":
          this.analysisType(e.type);
          break;
        case "trendType":
          this.trendType(e.type);
          break;
      }
    },
    rankType(type) {
      this.setTypeActive(".index-ranking", type);
    },
    analysisType(type) {
      this.setTypeActive(".index-analysis", type);
    },
    trendType(type) {
      this.setTypeActive(".index-trend", type);
    },
    setTypeActive(typeClass, type) {
      let types = document.querySelectorAll(typeClass + " .time-type");
      types.forEach(e => {
        if (e.classList.length >= 3) {
          e.classList.remove("active");
        }
      });
      switch (type) {
        case "year":
          types[0].classList.add("active");
          break;
        case "month":
          types[1].classList.add("active");
          break;
        case "day":
          types[2].classList.add("active");
          break;
      }
    },
    hideDetail() {
      this.visibleWindow = false;
    },
    moreWindow() {
      this.visibleWindow = true;
      this.showtype = "broadcastList";
      this.addDowm = true;
      setTimeout(() => {
        this.addDowm = false
      }, 500);
    },
    showDispatcher() {
      this.visibleWindow = true;
      this.showtype = 'dispatcherList';
      this.addDowm = true;
      setTimeout(() => {
        this.addDowm = false
      }, 500);
    },
    showMediator() {
      this.visibleWindow = true;
      this.showtype = 'mediatorList';
      this.addDowm = true;  
      setTimeout(() => {
        this.addDowm = false
      }, 500);    
    },
    mediatorDeatil(index) {
      console.log(index);
      this.visibleWindow = true;
      this.showtype = 'mediatorDetail';
    },
    dispatcherDeatil(index) {
      console.log(index);
      this.visibleWindow = true;
      this.showtype = 'dispatcherDetail';
    },
    broadcastDetail(index) {
      console.log(index);
      this.visibleWindow = true;
      this.showtype = 'broadcastDetail';
    },
    backList(listName) {
      this.visibleWindow = true;
      this.showtype = listName;
    }
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() { },
  mounted() {
    setTimeout(() => {
      this.rankData = [
        {
          name: "徐汇区",
          value: 1434
        },
        {
          name: "静安区",
          value: 5343
        },
        {
          name: "黄浦区",
          value: 806
        },
        {
          name: "奉贤区",
          value: 23
        },
        {
          name: "青浦区",
          value: 8116
        },
        {
          name: "浦东新区",
          value: 200
        },
        {
          name: "松江区",
          value: 200
        },
        {
          name: "闵行区",
          value: 220
        },
        {
          name: "宝山区",
          value: 1000
        },
        {
          name: "嘉定区",
          value: 445
        },
        {
          name: "金山区",
          value: 321
        },
        {
          name: "虹口区",
          value: 33
        },
        {
          name: "杨浦区",
          value: 1236
        },
        {
          name: "普陀区",
          value: 230
        },
        {
          name: "长宁区",
          value: 100
        },
        {
          name: "崇明区",
          value: 500
        }
      ];
      this.trendData = [
        {
          name: "total",
          date: "03-21",
          value: 90
        },
        {
          name: "total",
          date: "03-20",
          value: 30
        },
        {
          name: "total",
          date: "03-19",
          value: 44
        },
        {
          name: "total",
          date: "03-18",
          value: 56
        },
        {
          name: "total",
          date: "03-17",
          value: 34
        },
        {
          name: "total",
          date: "03-16",
          value: 99
        },
        {
          name: "total",
          date: "03-15",
          value: 2
        },
        {
          name: "total",
          date: "03-14",
          value: 100
        },
        {
          name: "total",
          date: "03-13",
          value: 45
        },
        {
          name: "mediate",
          date: "03-21",
          value: 50
        },
        {
          name: "mediate",
          date: "03-20",
          value: 29
        },
        {
          name: "mediate",
          date: "03-19",
          value: 10
        },
        {
          name: "mediate",
          date: "03-18",
          value: 20
        },
        {
          name: "mediate",
          date: "03-17",
          value: 33
        },
        {
          name: "mediate",
          date: "03-16",
          value: 34
        },
        {
          name: "mediate",
          date: "03-15",
          value: 1
        },
        {
          name: "mediate",
          date: "03-14",
          value: 44
        },
        {
          name: "mediate",
          date: "03-13",
          value: 35
        }
      ]
    }, 500);
  }
};
</script>
<style>
.index-wrapper .el-scrollbar__wrap {
  width: calc(100% + 17px);
  height: calc(100% + 17px);
}
.index-wrapper .el-scrollbar__bar.is-vertical {
  background-color: #062e4f;
}
.index-wrapper .el-scrollbar__bar.is-vertical > div {
  background-color: #40dbf8;
}
.index-wrapper .el-select > .el-input {
  height: 100%;
}
.index-wrapper .el-select .el-input__inner {
  height: 100%;
  background-color: transparent;
  border: none;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.index-wrapper .el-select .el-input__inner::placeholder {
  color: #fff;
}
.select-class.el-select-dropdown.el-popper .popper__arrow {
  display: none;
}
.list-select.select-class.el-select-dropdown.el-popper {
  margin: 0;
  background-color: #166f9a;
  border: 1px solid #166f9a;
}
.select-class.el-select-dropdown.el-popper {
  margin: -1px;
  border-radius: 0;
  background-color: #2299c5;
  border: 1px solid #2299c5;
}
.select-class .el-select-dropdown__item {
  color: #fff;
  text-align: center;
}
.select-class .el-select-dropdown__item.hover {
  background-color: transparent;
}
.select-class .el-select-dropdown__item:hover,
.select-class .el-select-dropdown__item.selected {
  background-color: #00749f;
  color: #fff;
}
.list-select.select-class .el-select-dropdown__item:hover,
.list-select.select-class .el-select-dropdown__item.selected {
  background-color: #04547a;
  color: #fff;
}
.index-wrapper .el-icon-arrow-up {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.index-wrapper .el-select .el-input .el-select__caret {
  color: #fff;
}
.index-wrapper .el-icon-arrow-up::before {
  content: "\e77a";
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../assets/scss/common.scss";
.index-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  .map-warpper {
    width: 100%;
    height: calc(100% - 80px);
    z-index: 0;
  }
  .cart-box {
    width: 50%;
    height: 200px;
  }
  #chartDemo {
    width: 100%;
    height: 100%;
  }
  .index-left {
    position: absolute;
    top: 80px;
    left: 0;
    width: 25.8%;
    height: calc(100% - 80px);
    padding: 20px 20px 0 20px;
    background-image: linear-gradient(to right, #012540, transparent);
  }
  .index-right {
    position: absolute;
    top: 80px;
    right: 0;
    width: 25.8%;
    height: calc(100% - 80px);
    padding: 20px 20px 0 20px;
    background-image: linear-gradient(to right, transparent, #012540);
  }
  .mask-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 26.7%;
    background-image: linear-gradient(to bottom, transparent, #012540);
  }
  .index-bottom {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 48.4%;
    height: 26.7%;
    transform: translateX(-50%);
    padding-bottom: 20px;
  }
  .index-top {
    position: absolute;
    top: 100px;
    left: 50%;
    z-index: 111;
    transform: translateX(-50%);
    width: 48.4%;
    height: calc(73.3% - 100px);
    padding-bottom: 20px;
    &.down-move {
      animation: downMove .5s linear;
    }
  }
  @keyframes downMove {
    0% {
      opacity: 0;
      transform: translateX(-50%) translateY(calc(-100% - 100px));      
    }
    100% {
      opacity: 1;
      transform: translateX(-50%) translateY(0);      
    }
  }
  .index-overview {
    width: 100%;
    height: 31.5%;
    padding-bottom: 20px;
    .data-line {
      width: 100%;
      height: 50%;
      box-sizing: border-box;
      border-bottom: 1px solid #333b6480;
      &:last-of-type {
        border-bottom-color: transparent;
      }
    }
    .overview-min {
      position: relative;
      width: 36%;
      height: 100%;
      padding-left: 12px;
      text-align: left;
      &:first-of-type .overview-data {
        color: $blue;
      }
      &:last-of-type {
        width: 26%;
      }
    }
    .out-line {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      padding-left: 12px;
    }
    .overview-title {
      line-height: 40px;
      font-size: 14px;
      color: $white;
    }
    .overview-contentdata {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .overview-data {
      width: 100%;
      color: $white;
      font-size: 36px;
      font-weight: bold;
    }
    .overview-precent {
      font-size: 16px;
      color: $pink;
    }
    .overview-arrowicon {
      padding-right: 4px;
      color: $pink;
    }
    .overview-state {
      position: absolute;
      bottom: 0;
      right: 0;
      &.down {
        .overview-precent,
        .overview-arrowicon {
          color: $green;
        }
        .overview-arrowicon {
          transform: rotate(180deg);
        }
      }
    }
  }
  .index-power {
    width: 100%;
    height: 37%;
    padding-bottom: 20px;
    .power-title-line {
      width: 100%;
      height: 75px;
      padding-top: 20px;
    }
    .power-title-box {
      position: relative;
      width: calc(50% - 13px);
      height: 55px;
    }
    .power-title-name {
      position: absolute;
      left: 0;
      top: 0;
      width: 88px;
      text-align: center;
      line-height: 48px;
      color: $white;
      font-size: 16px;
      font-weight: normal;
      background-color: #166f9a;
      cursor: pointer;
      &:hover {
        color: #3fe8f6;
      }
    }
    .power-num {
      position: absolute;
      left: 7px;
      top: 5px;
      width: calc(100% - 18px);
      height: 50px;
      padding-left: 78px;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      line-height: 46px;
      color: $blue;
      border-top: 2px solid #166f9a;
      border-bottom: 2px solid #166f9a;
      &::before {
        position: absolute;
        left: -4px;
        bottom: 0;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-bottom-color: #166f9a;
        border-left-color: #166f9a;
        transform: rotate(45deg);
        content: "";
      }
    }
    .power-arrow {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 11px;
      height: 50px;
      overflow: hidden;
      background: url("../../public/images/title_arrow.png") no-repeat
        center/cover;
    }
    .power-scroll-content {
      height: calc(100% - 75px);
      padding: 19px 0;
    }
    .power-content {
      width: 100%;
      height: 100%;
    }
    .mediate-msg {
      display: block;
      width: calc(100% - 18px);
      height: 44px;
      padding-left: 16px;
      margin-right: 18px;
      margin-bottom: 8px;
      font-size: 16px;
      color: $white;
      line-height: 44px;
      text-align: left;
      background-color: #052b4c;
      overflow: hidden;
      &.new {
        background-color: #0d3a5e;
        .warn-msg-icon {
          background-image: url("../../public/images/warn_light_new.png");
        }
      }
      &.repeat {
        background-color: #0d3a5e;
        .warn-msg-icon {
          background-image: url("../../public/images/warn_light_repeat.png");
        }
      }
    }
    .warn-msg-icon {
      width: 9%;
      height: 100%;
      background: url("../../public/images/warn_light.png") no-repeat
        center/contain;
    }
    .msg-person {
      width: 24%;
      padding-left: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .msg-type {
      min-width: 32%;
    }
    .msg-nums {
      width: 31%;
      padding-right: 16px;
      text-align: left;
    }
  }
  .index-ranking {
    width: 100%;
    height: 31.5%;
    padding-bottom: 20px;
    .rank-content {
      width: 100%;
      height: 100%;
    }
    .rank-content-box {
      width: 100%;
      height: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .chart-rank {
      width: 100%;
      height: 460px;
    }
  }
  .index-110 {
    width: 100%;
    height: 29.5%;
    padding-bottom: 20px;
    .police-content {
      width: 100%;
      height: 100%;
      padding: 20px 0;
    }
    .police-list {
      width: 100%;
      height: 100%;
    }
    .list-page {
      width: 100%;
      padding-left: 10px;
      margin: 0;
    }
    .list-item {
      position: relative;
      width: 100%;
      padding: 0 22px 13px 16px;
      border-left: 1px dotted #4d677c;
      text-align: left;
      &::before {
        position: absolute;
        left: -7px;
        top: 0;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: $red;
        opacity: 0.3;
        content: "";
      }
      &::after {
        position: absolute;
        left: -4px;
        top: 3px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $red;
        content: "";
      }
    }
    .list-time {
      width: 100%;
      height: 25px;
      color: $white;
      font-size: 14px;
    }
    .list-content {
      width: 100%;
      padding: 10px 20px;
      line-height: 27px;
      background-color: #0d3a5e;
    }
    .police-master {
      color: $white;
      font-size: 16px;
    }
    .content-line {
      color: #aaaec3;
      font-size: 14px;
    }
  }
  .index-analysis {
    width: 100%;
    height: 33.5%;
    padding-bottom: 20px;
    .analysis-chart {
      width: 100%;
      height: calc(100% - 58px);
    }
  }
  .index-trend {
    width: 100%;
    height: 37%;
    padding-bottom: 20px;
    .trend-chart {
      width: 100%;
      height: calc(100% - 58px);
    }
  }
  .content-tabbar {
    width: 100%;
    border-radius: 2px;
    line-height: 36px;
    font-size: 16px;
    color: $white;
    border: 1px solid #166f9a;
    background-color: #093352;
    cursor: pointer;
    .content-tab {
      width: 50%;
      &:first-of-type {
        border-right: 1px solid #166f9a;
      }
      &.active {
        background-color: #166f9a;
      }
    }
  }
  .padding-20 {
    padding-top: 20px;
  }
  .progress-course {
    width: 100%;
    height: 100%;
    padding-left: 24px;
    .progress-arrow {
      width: 48px;
      height: 100%;
      background: url("../../public/images/progress_arrow.png") no-repeat
        center/contain;
    }
    .progress-person {
      display: flex;
      justify-content: center;
      align-items: Center;
      width: 6.3%;
      height: 100%;
      color: $white;
      font-size: 55px;
      text-align: center;
    }
    .progress-police {
      display: flex;
      justify-content: center;
      align-items: Center;
      width: 11.5%;
      height: 100%;
      text-align: center;
      color: $white;
      font-size: 16px;
      .progress-num {
        color: #ede73b;
      }
    }
    .progress-web {
      display: flex;
      justify-content: center;
      align-items: Center;
      width: 13.6%;
      height: 100%;
      text-align: center;
      color: $white;
      font-size: 16px;
    }
    .progress-center {
      display: flex;
      justify-content: center;
      align-items: Center;
      width: 9.6%;
      height: 100%;
      text-align: center;
      color: $white;
      font-size: 16px;
    }
    .progress-branch {
      position: relative;
      width: calc(59% - 192px);
      height: 100%;
      text-align: center;
      color: $white;
      font-size: 16px;
      text-align: left;
    }
    .progress-num {
      font-size: 20px;
      font-weight: bold;
      color: $blue;
    }
    .branch-first {
      position: absolute;
      left: 20%;
      top: 0%;
      width: 100px;
      height: 100%;
    }
    .branch-second {
      position: absolute;
      left: 75%;
      top: 0%;
      width: 65px;
      height: 100%;
    }
    .branch-num {
      font-size: 20px;
      font-weight: bold;
    }
    .num-orange {
      color: $orange;
    }
    .num-red {
      color: $pink;
    }
    .num-green {
      color: $green;
    }
    .num-blue {
      color: $blue;
    }
    .barnch-top {
      position: absolute;
      top: 4%;
      left: 0;
    }
    .branch-center {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-40%);
    }
    .branch-end {
      position: absolute;
      top: 100%;
      left: 0;
      transform: translateY(-113%);
    }
    .branch-line-first {
      position: absolute;
      left: 4%;
      top: 0;
      width: 13.3%;
      height: 100%;
      padding-top: 10%;
      padding-bottom: 34px;
    }
    .branch-line-second {
      left: 59%;
      .branch-line3 {
        width: calc(374% - 48px);
        left: auto;
        right: 0;
      }
    }
    .branch-content-box {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .branch-line {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 1px;
      background-image: repeating-linear-gradient(
        90deg,
        #fff,
        #fff 5px,
        transparent 0,
        transparent 8px
      );
      animation: moving-line-width 2s linear infinite;
    }
    .branch-line2 {
      top: auto;
      bottom: 0;
    }
    .branch-line3 {
      top: 50%;
    }
    .branch-rotate-line {
      position: absolute;
      left: 0;
      top: 0;
      width: 1px;
      height: 50%;
      background-image: repeating-linear-gradient(
        180deg,
        #fff,
        #fff 5px,
        transparent 0,
        transparent 8px
      );
      animation: moving-line-top 2s linear infinite;
    }
    .branch-rotate-line2 {
      top: auto;
      bottom: 0;
      animation: moving-line-width 2s linear infinite;
    }
    @keyframes moving-line-width {
      0% {
        background-position: -42px -42px;
      }
      100% {
        background-position: -1px -1px;
      }
    }
    @keyframes moving-line-top {
      0% {
        background-position: -1px -1px;
      }
      100% {
        background-position: -42px -42px;
      }
    }
  }
  .index-search {
    position: absolute;
    right: -1px;
    top: 21px;
    width: 316px;
    height: 36px;
    line-height: 34px;
    transform: translateX(100%);
    border: 1px solid #3cb8e6;
    background-color: $brand;
    .search-icon-btn {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      padding-right: 16px;
      color: $white;
      font-size: 22px;
      cursor: pointer;
    }
    .search-box {
      width: 100%;
      padding: 0 48px 0 16px;
      margin: 0;
      border: none;
      overflow: hidden;
      color: $white;
      font-size: 16px;
      background-color: transparent;
      &:focus {
        outline: none;
      }
      &::placeholder {
        color: #bcedff;
      }
    }
  }
  .map-select-area {
    position: absolute;
    left: -165px;
    top: 21px;
    width: 120px;
    height: 36px;
    transform: translateX(-100%);
    border: 1px solid #3cb8e6;
    background-color: $brand;
  }
  .map-select-name {
    position: absolute;
    left: -1px;
    top: 21px;
    width: 144px;
    height: 36px;
    transform: translateX(-100%);
    border: 1px solid #3cb8e6;
    background-color: $brand;
  }
  .scroll-deatil {
    position: relative;
    width: 100%;
    height: 100%;
    .detail-content-box {
      width: 100%;
      padding-right: 18px;
    }
  }
  .detail-content-box {
    width: 100%;
    padding-right: 18px;
  }
  .broadcas-list {
    width: 100%;
    margin: 0;
    padding: 0;
    color: $white;
    font-size: 14px;
    text-align: left;
    padding-top: 46px;
    .broadcas-title {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: calc(100% - 18px);
      height: 46px;
      line-height: 46px;
      background-color: #166f9a;
    }
    .broadcast-num {
      width: 22.5%;
      padding-left: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .broadcast-time {
      width: 19.6%;
      padding-left: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .broadcast-person {
      width: 8.6%;
      padding-left: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .broadcast-disc {
      width: 31.1%;
      padding-left: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .broadcast-status {
      width: 18.2%;
      padding-left: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      z-index: 1;
    }
    .broadcas-list-item {
      width: 100%;
      border-bottom: 1px solid #333b64;
      &:hover {
        background-color: #166f9a
      }
    }
    .broadcas-item {
      display: block;
      width: 100%;
      color: $white;
      line-height: 61px;
      font-weight: normal;
      .broadcast-status {
        position: relative;
        padding-left: 36px;
        &::before {
          position: absolute;
          left: 24px;
          top: 50%;
          transform: translateY(-50%);
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: #f19149;
          content: "";
        }
        &.bureaus::before {
          background-color: #e83d12;
        }
        &.office::before {
          background-color: #ede73b;
        }
        &.committee::before {
          background-color: $blue;
        }
        &.end::before {
          background-color: $green;
        }
        &.receive::before {
          background-color: #743eff;
        }
      }
    }
  }
  .peopleList-nav {
    position: absolute;
    left: 0;
    top: 0;
    width: calc(100% - 18px);
    padding-right: 23px;
    line-height: 48px;
    color: $white;
    font-size: 16px;
    background-color: #166f9a;
    .nav-area {
      position: absolute;
      top: 0;
      left: 0;
      width: 120px;
      height: 48px;
    }
    .nav-place {
      position: absolute;
      top: 0;
      left: 123px;
      width: 150px;
      height: 48px;
    }
  }
  .peopleList-content-box {
    width: 100%;
    margin: 0;
    padding: 68px 0 0 0;
    list-style: none;
    .peopleList-box {
      list-style: none;
      float: left;
      width: calc((100% - 60px) / 4);
      padding: 30px 20px 22px;
      margin-right: 20px;
      margin-bottom: 20px;
      border: 1px solid #166f9a;
      cursor: pointer;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
      &:hover {
        background-color: #166f9a
      }
    }
    .peopleList-img {
      margin: 0 auto;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .peopleList-name {
      width: 100%;
      padding-top: 14px;
      line-height: 34px;
      color: $white;
      font-size: 18px;
      text-align: center;
    }
    .peopleList-place {
      width: 100%;
      line-height: 27px;
      color: $white;
      font-size: 14px;
      text-align: center;
    }
  }
  .mediator-detail {
    padding-right: 20px;
    width: 100%;
    height: auto;
    .detail-inner {
      position: relative;
      width: 100%;
      height: auto;
      background-color: #0f557f;
      margin-bottom: 24px;
    }
    .detail-title {
      padding: 16px 30px;
      width: 100%;
      height: auto;
      line-height: 1;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      text-align: left;
      border-bottom: 1px solid #256185;
    }
    .detail-body {
      padding: 20px 30px 30px 30px;
      width: 100%;
      height: auto;
      .head-portrait {
        width: 110px;
        height: 134px;
      }
      .head-pic {
        width: 100%;
        height: 100%;
      }
      .basic-msg {
        position: relative;
        padding-left: 20px;
        width: calc(100% - 110px);
        height: auto;
      }
      .name {
        padding-bottom: 10px;
        line-height: 1;
        font-size: 24px;
        font-weight: bold;
        color: #fff;
        text-align: left;
      }
      .type {
        margin-left: 10px;
        font-size: 16px;
      }
      .other-msg {
        padding: 8px 0;
        text-align: left;
        font-size: 14px;
        color: #fff;
      }
      .middle {
        width: 40%;
        &:first-child {
          width: 20%;
        }
      }
      .msg-bottom {
        width: 40%;
        &:last-child {
          width: 60%;
        }
      }
      .sirens-num-wrap {
        position: absolute;
        right: 0;
        top: 0;
      }
      .num-hd {
        font-size: 14px;
        color: #fff;
      }
      .num-bd {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #fff;
      }
      .mr-80 {
        margin-right: 80px;
      }
      .detail-info {
        padding-right: 8px;
      }
    }
    .broadcast-link-btn {
      position: absolute;
      right: 30px;
      top: 24px;
      color: $white;
      width: 116px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      font-size: 18px;
      text-align: center;
      background-color: #0a92d9;
      cursor: pointer;
      .iconshipinlianxian {
        display: inline-block;
        font-size: 22px;
        vertical-align: baseline;
      }
    }
    .broadcast-detail-title {
      color: #40dbf8;
      font-size: 24px;
      font-weight: bold;
      line-height: 70px;
      .iconanli {
        font-size: 26px;
        padding-left: 30px;
        padding-right: 16px;
      }
    }
    .broadcast-detail-record {
      list-style: none;
      padding: 0 34px 0;
      margin: 0;
      width: 100%;
      overflow: hidden;
    }
    .broadcast-record-item {
      position: relative;
      padding: 6px 0 4px 25px;
      margin: 0;
      list-style: none;
      width: 100%;
      line-height: 30px;
      font-size: 14px;
      color: $white;
      text-align: left;
      .record-time {
        font-weight: bold;
      }
      &::before {
        position: absolute;
        left: 0;
        top: 32px;
        width: 2px;
        height: calc(100% - 18px);
        background-color: #40dbf8;
        content: '';
      }
      &::after {
        position: absolute;
        left: -4px;
        top: 18px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #40dbf8;
        content: '';
      }
    }
    .show-more-btn {
      padding-bottom: 7px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      color: $white;
      font-style: 14px;
    }
    .more-arrow {
      display: inline-block;
      width: 10px;
      height: 10px;
      border: 1px solid transparent;
      border-left-color: $white;
      border-bottom-color: $white;
      transform: translateY(-3px) rotate(-45deg);
    }
  }
  .mediator .detail-info:nth-child(3n + 1) {
    width: 30%;
  }
  .mediator .detail-info:nth-child(3n + 2) {
    width: 50%;
  }
  .mediator .detail-info:nth-child(3n) {
    width: 20%;
  }
  .dispatcher .detail-info {
    width: 33.33%;
  }
}
</style>